import React from 'react';
import PropTypes from 'prop-types';
import { SuiCheckbox, SuiContainer } from '@splashthat/sui';
import { connect } from 'react-redux';

import disableWhenLocked from './disableWhenLocked';
import { getCheckedValue } from '../../../selectors';
import { updateFormNodeConfigChecked } from '../../../actions/nodeOptionActions';

const CHECKBOX_LABEL = 'Checkbox is checked by default for guests.';

/**
 * UI piece to set a checkbox question set by default.
 */
const CheckboxDefaultValueControl = (props) => {
    const handleToggle = (event, value) => {
        props.onChangeChecked(value);
    };

    return (
        <SuiContainer variation="flex-vertical flex-inherit">
            <SuiContainer variation="flex-group">
                <SuiCheckbox
                    label={CHECKBOX_LABEL}
                    checked={props.checked}
                    onChange={handleToggle}
                    disabled={props.disabled}
                />
            </SuiContainer>
        </SuiContainer>
    );
};

CheckboxDefaultValueControl.propTypes = {
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
    checked: PropTypes.bool.isRequired,
    onChangeChecked: PropTypes.func.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => ({
    checked: getCheckedValue(state, props.formNodeId),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChangeChecked: (checked) => dispatch(updateFormNodeConfigChecked(ownProps.formNodeId, checked)),
});

const ConnectedCheckboxDefaultValueControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(CheckboxDefaultValueControl));

ConnectedCheckboxDefaultValueControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedCheckboxDefaultValueControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedCheckboxDefaultValueControl;
